import createIcon from '../../createIcon';

/**
 * @component @name SportsEsports
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNTc5OCAxNi4wOUwyMC40ODk4IDguNDNDMjAuMjA5OCA2LjQ2IDE4LjUxOTggNSAxNi41Mjk4IDVINy40Njk4MkM1LjQ3OTgyIDUgMy43ODk4MiA2LjQ2IDMuNTA5ODIgOC40M0wyLjQxOTgyIDE2LjA5QzIuMTk5ODIgMTcuNjMgMy4zODk4MiAxOSA0LjkzOTgyIDE5QzUuNjE5ODIgMTkgNi4yNTk4MiAxOC43MyA2LjczOTgyIDE4LjI1TDguOTk5ODIgMTZIMTQuOTk5OEwxNy4yNDk4IDE4LjI1QzE3LjcyOTggMTguNzMgMTguMzc5OCAxOSAxOS4wNDk4IDE5QzIwLjYwOTggMTkgMjEuNzk5OCAxNy42MyAyMS41Nzk4IDE2LjA5Wk0xOS40Nzk4IDE2LjgxQzE5LjM5OTggMTYuOSAxOS4yNjk4IDE3IDE5LjA1OTggMTdDMTguOTA5OCAxNyAxOC43Njk4IDE2Ljk0IDE4LjY2OTggMTYuODRMMTUuODI5OCAxNEg4LjE2OTgyTDUuMzI5ODIgMTYuODRDNS4yMjk4MiAxNi45NCA1LjA4OTgyIDE3IDQuOTM5ODIgMTdDNC43Mjk4MiAxNyA0LjU5OTgyIDE2LjkgNC41MTk4MiAxNi44MUM0LjQzOTgyIDE2LjcyIDQuMzU5ODIgMTYuNTggNC4zODk4MiAxNi4zN0w1LjQ3OTgyIDguNzFDNS42Mjk4MiA3Ljc0IDYuNDc5ODIgNyA3LjQ2OTgyIDdIMTYuNTI5OEMxNy41MTk4IDcgMTguMzY5OCA3Ljc0IDE4LjUwOTggOC43MkwxOS41OTk4IDE2LjM4QzE5LjYyOTggMTYuNTggMTkuNTQ5OCAxNi43MiAxOS40Nzk4IDE2LjgxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguOTk5ODIgOEg3Ljk5OTgyVjEwSDUuOTk5ODJWMTFINy45OTk4MlYxM0g4Ljk5OTgyVjExSDEwLjk5OThWMTBIOC45OTk4MlY4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2Ljk5OTggMTNDMTcuNTUyMSAxMyAxNy45OTk4IDEyLjU1MjMgMTcuOTk5OCAxMkMxNy45OTk4IDExLjQ0NzcgMTcuNTUyMSAxMSAxNi45OTk4IDExQzE2LjQ0NzUgMTEgMTUuOTk5OCAxMS40NDc3IDE1Ljk5OTggMTJDMTUuOTk5OCAxMi41NTIzIDE2LjQ0NzUgMTMgMTYuOTk5OCAxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC45OTk4IDEwQzE1LjU1MjEgMTAgMTUuOTk5OCA5LjU1MjI4IDE1Ljk5OTggOUMxNS45OTk4IDguNDQ3NzIgMTUuNTUyMSA4IDE0Ljk5OTggOEMxNC40NDc1IDggMTMuOTk5OCA4LjQ0NzcyIDEzLjk5OTggOUMxMy45OTk4IDkuNTUyMjggMTQuNDQ3NSAxMCAxNC45OTk4IDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsEsports = createIcon('SportsEsports', [
  [
    'path',
    {
      d: 'M21.5798 16.09L20.4898 8.43C20.2098 6.46 18.5198 5 16.5298 5H7.46982C5.47982 5 3.78982 6.46 3.50982 8.43L2.41982 16.09C2.19982 17.63 3.38982 19 4.93982 19C5.61982 19 6.25982 18.73 6.73982 18.25L8.99982 16H14.9998L17.2498 18.25C17.7298 18.73 18.3798 19 19.0498 19C20.6098 19 21.7998 17.63 21.5798 16.09ZM19.4798 16.81C19.3998 16.9 19.2698 17 19.0598 17C18.9098 17 18.7698 16.94 18.6698 16.84L15.8298 14H8.16982L5.32982 16.84C5.22982 16.94 5.08982 17 4.93982 17C4.72982 17 4.59982 16.9 4.51982 16.81C4.43982 16.72 4.35982 16.58 4.38982 16.37L5.47982 8.71C5.62982 7.74 6.47982 7 7.46982 7H16.5298C17.5198 7 18.3698 7.74 18.5098 8.72L19.5998 16.38C19.6298 16.58 19.5498 16.72 19.4798 16.81Z',
      key: '1orjez',
    },
  ],
  [
    'path',
    {
      d: 'M8.99982 8H7.99982V10H5.99982V11H7.99982V13H8.99982V11H10.9998V10H8.99982V8Z',
      key: '1f4cn8',
    },
  ],
  [
    'path',
    {
      d: 'M16.9998 13C17.5521 13 17.9998 12.5523 17.9998 12C17.9998 11.4477 17.5521 11 16.9998 11C16.4475 11 15.9998 11.4477 15.9998 12C15.9998 12.5523 16.4475 13 16.9998 13Z',
      key: '3oztg9',
    },
  ],
  [
    'path',
    {
      d: 'M14.9998 10C15.5521 10 15.9998 9.55228 15.9998 9C15.9998 8.44772 15.5521 8 14.9998 8C14.4475 8 13.9998 8.44772 13.9998 9C13.9998 9.55228 14.4475 10 14.9998 10Z',
      key: '4kswh3',
    },
  ],
]);

export default SportsEsports;
